import React from 'react';
import { useSparesInputQuery } from '../../../../../services';
import { RhMultipleAutocomplete } from '../../../../dum';

interface ISMultipleSparesAutocompleteProps {
    name: string;
    label: string;
    multipleValue: string;
    disableGutters?: boolean;
}

export function SMultipleSparesAutocomplete({
    name,
    multipleValue,
    label,
    disableGutters = false,
}: ISMultipleSparesAutocompleteProps) {
    const { data } = useSparesInputQuery();

    const spares = data?.getSpares || [];

    return (
        <RhMultipleAutocomplete
            itemText={'name'}
            itemValue={'id'}
            disableGutters={disableGutters}
            multipleValue={multipleValue}
            name={name}
            label={label}
            options={spares}
        />
    );
}
